const PADDING_HORIZONTAL = 24;

const PADDING_VERTICAL = 16;

const PROMPT_DEFAULT_FONT_SIZE = 24;

export default class SharePostcardMaker {
  constructor(){
    this.scale = 1;
    this.postcardW = 400;
    this.postcardH = 500;
    this.canvas = document.createElement('canvas');
    this.canvas.width = this.postcardW;
    this.canvas.height = this.postcardH;
    this.context = this.canvas.getContext('2d');
    this.context.imageSmoothingEnabled = false;

    this.topPositionInc = PADDING_VERTICAL;

    this.gacImg = new Image();
    this.gacImg.src = this.getGACLogoBase64();
  }

  makePostcard(img,promptEl){
     this.topPositionInc = PADDING_VERTICAL;

     // clear canvas
     this.context.clearRect(0, 0, this.postcardW, this.postcardW);

     // draw white background
     this.context.fillStyle = "#FFFFFF";
     this.context.fillRect(0,0, this.postcardW, this.postcardH);

     // draw the logo
     const logoHeight = this.gacImg.height
     this.context.drawImage(this.gacImg, PADDING_HORIZONTAL, this.topPositionInc, this.gacImg.width, logoHeight);
     this.topPositionInc += logoHeight

     // draw link
     this.context.font = '12px Google Sans';
     this.context.fillStyle = '#1558D6';
     this.context.textAlign = 'right';
     this.context.fillText("goo.gle/ArtRemix", this.postcardW - PADDING_HORIZONTAL, this.topPositionInc - 4);

     // Margin between logo and image
     this.topPositionInc += 8;

     // draw the image
     const imageWidth = this.postcardW - 2 * PADDING_HORIZONTAL;
     const imageHeight = imageWidth - 10;
     this.context.drawImage(img, 0, 5, 1024, 1024, PADDING_HORIZONTAL, this.topPositionInc, imageWidth, imageHeight);
     this.topPositionInc += imageHeight;

     // draw ai message
     const aiMessageHeight = 24;
     this.context.fillStyle = "#4d4d4d";
     /* -2 on topPosition because there's a tiny border. No idea why. */
     this.context.fillRect(PADDING_HORIZONTAL, this.topPositionInc - 2, this.postcardW - 2 * PADDING_HORIZONTAL, aiMessageHeight);

     this.context.font = `500 12px Google Sans`;
     this.context.fillStyle = "#FFFFFF";
     this.context.textAlign = 'right';
     this.context.fillText("AI Generated with Google tools",  this.postcardW - PADDING_HORIZONTAL - 10, this.topPositionInc + (aiMessageHeight + 4) / 2);
     this.context.textAlign = 'left';

     this.topPositionInc += aiMessageHeight;

     // Margin ai message and prompt
     this.topPositionInc += 16 + 8;

     // draw prompt
     this.addPromptText(promptEl);
    }

  getInspiredByText(asset_data){

    if( asset_data.creators.length == 0 && asset_data.title.length == 0){
      return "";
    }

    let inspText = "Inspired by ";


    if(asset_data.title.length > 0){
      inspText += asset_data.title;
    }

    return inspText;
  }

  addPromptText(promptEl) {
    const spansList = [];

    //promptEl.children[0].innerText = 'this a long text to test out because we need to in case its breaking, we never know';
    //promptEl.children[0].innerText = '';
    //promptEl.children[1].innerText = '';
    //promptEl.children[2].innerText = '';

    const wordsList = [];
    for (const span of promptEl.children) {
      const spanWords = span.innerText.split(' ');

      for (const word of spanWords) {
        if (word) {
          wordsList.push({
            text: word,
            index: span.getAttribute('data-index'),
          });
        }
      }
    }

    const linesToDraw = this.getLinesToDraw(wordsList);

    // Draw the selection highlight
    const magicPerc = (linesToDraw.fontSize - 12) / (PROMPT_DEFAULT_FONT_SIZE - 12);
    const selectionHorizontalPadding = 2;
    const selectionVerticalPadding = -2 * magicPerc; // between -2 and -9
    const selectionVerticalShift = -2 * (1 - magicPerc); // between 1 and 9
    const backgroundColors = ['#FFC954', '#AAD2B5', '#AED0F7'];
    const textColors = ['#7C5E1B', '#146C2E', '#0B57D0'];

    for (const selection of linesToDraw.selections) {
      const selectionX = selection.start + PADDING_HORIZONTAL - selectionHorizontalPadding;
      const selectionY = this.topPositionInc + (selection.lineIndex - 1) * linesToDraw.lineHeight + 7 - selectionVerticalPadding + selectionVerticalShift;
      const selectionWidth = selection.width + selectionHorizontalPadding * 2;
      const selectionHeight = linesToDraw.lineHeight + selectionVerticalPadding * 2;

      this.context.fillStyle = backgroundColors[selection.index];
      this.context.beginPath();
      this.context.roundRect(
        selectionX, 
        selectionY,
        selectionWidth,
        selectionHeight,
        4
      );

      if (selection.isPreviousWordASelection) {
        this.context.fillRect(
          selectionX - 4, 
          selectionY,
          12,
          selectionHeight
        );
      }

      this.context.fill();
    }

    // Draw the text
    this.context.font = `500 ${linesToDraw.fontSize}px Google Sans`;
    this.context.fillStyle = "#000000";
    this.context.textAlign = 'left';

    let inc = 0;
    for (const line of linesToDraw.lines) {
      this.context.fillText(line, PADDING_HORIZONTAL, this.topPositionInc + inc * linesToDraw.lineHeight);
      inc++;
    }
  }

  getLinesToDraw(wordsList, fontSize = PROMPT_DEFAULT_FONT_SIZE) {
    this.context.font = `500 ${fontSize}px Google Sans`;

    const displayLines = [];
    const selections = [];
    let lineText= '';

    let isPreviousWordASelection = false;
    for (const word of wordsList) {
      if (this.context.measureText(lineText + word.text).width < this.postcardW - 2 * PADDING_HORIZONTAL) {
        if (lineText !== '') {
          lineText += ' ';
        }

        const beforeWidth = this.context.measureText(lineText).width;
        const afterWidth = this.context.measureText(lineText + word.text).width;

        lineText += word.text;

        if (word.index !== null) {
          selections.push({
            index: word.index,
            start: beforeWidth,
            width: afterWidth - beforeWidth,
            word: word.text,
            lineIndex: displayLines.length,
            isPreviousWordASelection,
          });
          isPreviousWordASelection = true;
        } else {
          isPreviousWordASelection = false;
        }

      } else {
        displayLines.push(lineText);
        lineText = word.text;

        if (word.index !== null) {
          selections.push({
            index: word.index,
            start: 0,
            width: this.context.measureText(word.text).width,
            word: word.text,
            lineIndex: displayLines.length,
          });
          isPreviousWordASelection = true;
        } else {
          isPreviousWordASelection = false;
        }
      }
    }

    displayLines.push(lineText);

    const lineHeight = fontSize * 1.4;
    const sizeToFitIn = this.postcardH - this.topPositionInc + 10;

    if (displayLines.length * lineHeight > sizeToFitIn) {
      return this.getLinesToDraw(wordsList, fontSize - 1);
    }

    return {
      fontSize,
      lines: displayLines,
      lineHeight,
      selections,
    }
  }

  getGACLogoBase64() {
    return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAAQCAYAAAA76nChAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPoSURBVHgB7ViLcdswDH3pdQB1A3YDdQN2gqYTRBvEmSDsBPYGViewM4GVCZJOYG8gb+AKFVBCEGXJubNzl/O7QyKRIL4UCPoGfTgmQoUrPjR8Q5uGDoq2DT3iMlix/rfANZThvCD5nukU/tuGckyHw/l9+Yc7xCTPEJ0rG6oRv/xzYsP6T4VDa/vUDZPh9KASP9lWs66xD+GeeWteJ7F1GAf5USi9U9acDIdoXDYwfwm8NelFQy9oAzslmQGnVxT6Wmt+9ixjCLQhtuhWBNfQAu0HNQad9AJvi8koyJgDTkuuR2vQ7cA6mfeJuUytlRJI/23SNd8xbJmP1gez3vFzjlg252g3ibxrXX5AB43XGN9UDtNiaed19ZGk0ztVDKkQGdJVyhkZElM9XsD4RkrqhKDCkCyinWzP/Vyt25r5F2XoHWKJPKhnj27S7838UGnMEYM8Q9cPz3MrHqf50thWsD8127llfiTiUWO8QgRMqyLic2qdJD0YWwPTckCWyJBjiMYk3uLb/2qeKqveKDwoY8QAgmOB8hWs0C1tmt8hBk6+whX6SXeIySK+HMNnNgVgzc+Zclb7EMyaYGSR/TMlw/KD7Sox3tiW6CclhSlJB/rlPeB40rVcx++6UpLsxafmzx/0O8aqoa+Kdjz+o6E9YmBo/BdiEknBE+JVr0SbFNpxOfM9sAxZayFV4xltgDcs7ynB69EmumDdr6xLI+A4fqOtLEuWt0joAOv4idjoOsTkCMivL3g/VIixpziSPZSzJeJm+fEZbVLIaQrwgxKw4/+OiRLkWZDGXvEdQ2b4x/jmbBsFukrwFYibzalxSv4DpoOS/Mrr5jz2DV2/5Jn4KA4rxApTKllrnqM1O7wvKDZk97Mae4aKf0BbCmg3OMXk0T0LCubT5XCj5nWJJuRKbsbPcyX/Ef3ynuK7R/+r2iBdSuX89izHIqAt6doGp95t6RV7cjW2wHDDtkFsFDXulL1SnfSaofKu+5QZurYX6J/pAp+w8R6moQvoN1iHhAMlYnMld1E5Nxy691LbhAUlX+vw6PYWmk/kBGWDQz85ggXL8kgnXcZXiMEiHXP0N61gptYslf0hIZ82SWn4N4ibUfyr1dwL0kmXPoXkyE1J3uUWMpR0KN+WiA2tvzFMDt12v0K6tMqvTFQqqKTtBmTsOQB7M18gnutkzHdEJ9eGL2VHxjaU6MOx/grxByaLXPG8Gn9KpI8gZ+zZ8fMOaXjETZmSW7DMimWQ/jWv2aF7vEq/UqEbv5LnaFyOurWx41iuzg7p7h/VmJT3DFd8WATE65eUpoArLoobXB4F4tWPuskSV1xxxXnxF5XhfRWXjwfjAAAAAElFTkSuQmCC';
  }

  getGACLogox2Base64() {
    return 'data:image/png;base64,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';
  }
}
